// extracted by mini-css-extract-plugin
module.exports = {"TickedList":"TickedList_TickedList__qV_sc","list":"TickedList_list__eVmke","item":"TickedList_item__vq4DR"};